import {
  Alert,
  Card,
  CardContent,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material"
import { isEqual } from "lodash"
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { dayjs, timeFormat } from "src/app/utils"
import { useLazyGetZipScheduleQuery } from "src/features/checkout/checkoutApi"

export default function ZipScheduleCard() {
  const { zip } = useSelector((state) => state.checkout.options)
  const [schedules, setSchedules] = useState([])
  const [getZipSchedule, { data, isLoading }] = useLazyGetZipScheduleQuery()

  useEffect(() => {
    getZipSchedule({ zip })
  }, [])

  useEffect(() => {
    if (!data?.slots) return

    setSchedules(
      data.slots.map((slot) => {
        if (slot.type === "weekday") {
          if (slot.value.split("").length === 7) {
            return {
              label: "Daily",
              value: `${timeFormat(slot.time_start)} - ${timeFormat(
                slot.time_end,
              )}`,
            }
          }
          if (isEqual(slot.value.split(""), ["1", "2", "3", "4", "5"])) {
            return {
              label: "Weekdays",
              value: `${timeFormat(slot.time_start)} - ${timeFormat(
                slot.time_end,
              )}`,
            }
          }
          return {
            label: slot.value
              .split("")
              .map((day) => dayjs().weekday(day).format("ddd"))
              .join(","),
            value: `${timeFormat(slot.time_start)} - ${timeFormat(
              slot.time_end,
            )}`,
          }
        }
      }),
    )
  }, [data])

  return (
    <Card sx={{ mb: 2 }}>
      <CardContent>
        <Typography component="div" variant="body1" m={0}>
          Delivery schedule for your ZIP Code is as follows:
          <Stack>
            {isLoading ? (
              <>
                <Skeleton animation="pulse" />
                <Skeleton animation="wave" />
                <Skeleton animation={false} />
              </>
            ) : schedules.length ? (
              schedules.filter(Boolean).map((schedule, i) => (
                <span key={i}>
                  • <strong>{schedule?.label}</strong> {schedule?.value}
                </span>
              ))
            ) : (
              <Alert severity="info">
                We currently don't have a delivery schedule for your zip code
                but our team will be in touch with you to schedule your
                delivery.
              </Alert>
            )}
          </Stack>
        </Typography>
      </CardContent>
    </Card>
  )
}
